import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import styles from './BreadcrumbsBanner.module.css';
import { useThemes } from '@hooks/useThemes';

export interface BreadcrumbsBannerProps {
    title: string;
    links: { name: string; url: string }[];
    currentPage: string;
    image?: string;
}

export const BreadcrumbsBanner: FC<BreadcrumbsBannerProps> = ({ title, links, currentPage, image }) => {
    const { t } = useTranslation();
    const { useGrayscaleTheme } = useThemes();

    const translations = {
        home: t('breadcrumbs-banner-component.home'),
    };

    return (
        <>
            <div
                className={`${styles['breadcrumbs-banner']} ${image ? styles['with-image'] : ''}`}
                style={image ? { backgroundImage: `url("${image}")` } : {}}
                data-testid="breadcrumbs">
                {image && <div className={styles['foreground']}></div>}
                <div
                    className={
                        `${styles['breadcrumbs-container']} d-flex align-items-end p-4` +
                        ` ${useGrayscaleTheme ? styles['theme-grayscale'] : ''}`
                    }>
                    <div className="w-100 text-center">
                        <Typography classes={`mb-1 ${image ? 'text-light' : 'text-dark'}`} tagVariant={TypographyTagVariants.h1} fontWeight="900" fontSize="36">
                            {title}
                        </Typography>
                        <Typography classes={`${!image ? 'mb-2' : ''}`} fontSize="16">
                            <>
                                <Anchor href="" mode={AnchorMode.none}>
                                    {translations.home}
                                </Anchor>
                                {links.map((item, index) => (
                                    <Fragment key={`link-${index}`}>
                                        <Typography classes="mx-1" tagVariant={TypographyTagVariants.span}>
                                            /
                                        </Typography>
                                        <Anchor href={item.url} mode={AnchorMode.none}>
                                            {item.name}
                                        </Anchor>
                                    </Fragment>
                                ))}
                                <Typography classes="mx-1" tagVariant={TypographyTagVariants.span}>
                                    /
                                </Typography>
                                <Typography tagVariant={TypographyTagVariants.span} fontWeight="800">
                                    {currentPage}
                                </Typography>
                            </>
                        </Typography>
                    </div>
                </div>
            </div>
            {!image && (
                <>
                    <hr className="my-0" />
                </>
            )}
        </>
    );
};
